import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const FacebookIcon = (props) => {
    return (
        <Icon viewBox="0 0 9 20" cursor="pointer" {...props}>
            <path
                d="M5.98461 20.0001V9.99895H8.64716L9 6.55249H5.98461L5.98913 4.82751C5.98913 3.92862 6.0715 3.44697 7.31664 3.44697H8.98115V0.00012207H6.31823C3.11962 0.00012207 1.9938 1.67203 1.9938 4.48364V6.55288H0V9.99934H1.9938V20.0001H5.98461Z"
                fill="currentColor"
            />
        </Icon>
    )
}

FacebookIcon.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
}

export default FacebookIcon
